import axios from "axios";

const api = axios.create({ baseURL: "https://api.autopf.com.br" });

export default api;
